import state from './storeCustomerState'
import mutations from './storeCustomerMutations'
import getters from './storeCustomerGetters'
import actions from './storeCustomerAction'

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
